export default __webpack_public_path__ + "static/media/gnb-m@3x.cf6c01eb.png";